module.exports = "<app-header  *ngIf=\"isAdmin\" ></app-header>\r\n<router-outlet *ngIf=\"isObsah\"></router-outlet>"